import React from 'react'

export default function Footer() {
  return (
    <footer className='bg-dark text-light text-center'>
      <section className='container p-5'>
        <div className='row'>
          <div className='col'>copyright 2020 | theDavidBarton</div>
        </div>
      </section>
    </footer>
  )
}
